import React from 'react'
import { css, cx } from '@emotion/css'
import { VulnerabilityPolicy } from '../index'
import { FormattedMessage } from 'react-intl'
import { paragraphTextCss } from '../../../legacy-design-system/text'
import { serverEnvI18n } from '../../server-environment'

export function EnvironmentsCell({
  rowData: { allServerEnvironments, serverEnvironments = [] },
  listDataTestID
}: {
  readonly rowData: VulnerabilityPolicy
  readonly listDataTestID?: string
}) {
  const listStyle = cx(
    paragraphTextCss,
    css`
      list-style: none;
      padding: 0;
      margin: 0;
    `
  )

  if (allServerEnvironments) {
    return (
      <FormattedMessage
        data-testid={listDataTestID}
        id="title_remediationPolicy_allEnvironments"
      >
        {(msg) => <span className={listStyle}>{msg} </span>}
      </FormattedMessage>
    )
  }

  return (
    <div className={listStyle} data-testid={listDataTestID}>
      {serverEnvironments.map((env, index) => (
        <FormattedMessage key={index} id={serverEnvI18n[env]}>
          {(msg) =>
            index === serverEnvironments.length - 1 ? (
              <span>{msg}</span>
            ) : (
              <span>{msg}, </span>
            )
          }
        </FormattedMessage>
      ))}
    </div>
  )
}
